import React, { useEffect, useState } from "react";
import { Button, Input, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { UI_DATE_FORMAT } from "../../../consts";

const BroccoliTable = ({
  siteMetadata,
  currentCrop,
  currentGreenhouse,
  currentPlot,
}) => {
  const [tableData, setTableData] = useState([]);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
  };

  useEffect(() => {
    if (siteMetadata && currentCrop && currentGreenhouse && currentPlot) {
      const tableData =
        siteMetadata?.[currentGreenhouse.name]?.[currentPlot.name]?.[
          "table_data"
        ];
      if (tableData) {
        setTableData(tableData);
      }
    }
  }, [siteMetadata, currentCrop, currentGreenhouse, currentPlot]);

  const columns = [
    {
      title: "Planting Date",
      dataIndex: "plantingDate",
      key: "plantingDate",
      sorter: (a, b) => dayjs(a.plantingDate).diff(dayjs(b.plantingDate)),
      render: (text) => dayjs(text).format(UI_DATE_FORMAT), // Format date
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search Date`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() =>
              handleSearch(selectedKeys, confirm, "plantingDate")
            }
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, "plantingDate")}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
        </div>
      ),
      onFilter: (value, record) =>
        dayjs(record.plantingDate).format(UI_DATE_FORMAT).includes(value),
    },
    {
      title: "Variety",
      dataIndex: "variety",
      key: "variety",
      sorter: (a, b) => a.variety.localeCompare(b.variety),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search Variety`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, "variety")}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, "variety")}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
        </div>
      ),
      onFilter: (value, record) => record.variety.includes(value),
    },
    {
      title: "Area",
      dataIndex: "area",
      key: "area",
      sorter: (a, b) => a.area - b.area,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search Area`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, "area")}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, "area")}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
        </div>
      ),
      onFilter: (value, record) => record.area.toString().includes(value),
    },
    {
      title: "Est. Harvest Date",
      dataIndex: "harvestDate",
      key: "harvestDate",
      sorter: (a, b) => dayjs(a.harvestDate).diff(dayjs(b.harvestDate)),
      render: (text) => (text ? dayjs(text).format(UI_DATE_FORMAT) : "-"), // Format date
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search Date`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() =>
              handleSearch(selectedKeys, confirm, "harvestDate")
            }
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, "harvestDate")}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
        </div>
      ),
      onFilter: (value, record) =>
        dayjs(record.harvestDate).format(UI_DATE_FORMAT).includes(value),
    },
  ];

  return (
    <>
      {tableData && tableData.length > 0 && (
        <Table
          dataSource={tableData}
          columns={columns}
          pagination={false}
          className="mb-5 w-full"
          scroll={{ x: 768 }}
        />
      )}
    </>
  );
};

export { BroccoliTable };
